import React, { Fragment } from 'react';
import { Marker } from 'react-leaflet';
import MarkerPopup from './MarkerPopup';
import { ParkIcon, ParkCostIcon } from "./LocationIcon";

const Markers = (props) => {
  const { data, isPopUp, iconType, checked } = props;
  const markers = data.map((item) => (
    item.lat !== "" && item.lat !== null ?
      <Marker key={`${item.lat} ${item.lng}`} position={[item.lat, item.lng]} icon={item?.has_cost ? ParkCostIcon : iconType}>
        {
          isPopUp && <MarkerPopup data={item} checked={checked} />
        }
      </Marker> :
      <></>
  ));

  return <>{markers}</>;
};

export default Markers;
